import React from 'react';
import { StyleSheet, SafeAreaView } from 'react-native';
import AppNavigator from './navigation/AppNavigator';
import { AuthProvider } from './context/AuthProvider';
import { OrganizationProvider } from './context/OrganizationProvider';
import { MainColors } from './constants/Colors';


const Providers = ({ children }) => {
  return (
    <OrganizationProvider>
      <AuthProvider>
        {children}
      </AuthProvider>
    </OrganizationProvider>
  )
} 

export default function App() {
  return (
    <SafeAreaView style={styles.container}>
      <Providers>
        <AppNavigator/>
      </Providers>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: MainColors.darkGray
  }
});
